import { isAnalyticsAllowed } from '@/lib/cookie-consent';

export interface AnalyticsEventPayload {
  event: string;
  [key: string]: string | number | boolean | undefined;
}

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export function pushAnalyticsEvent(payload: AnalyticsEventPayload): void {
  if (!isAnalyticsAllowed()) return;
  if (!Array.isArray(window.dataLayer)) return;
  window.dataLayer.push(payload);
}

export function getUtmPayloadFromUrl(url: string): Record<string, string> {
  const params = new URL(url).searchParams;
  return {
    utm_source: params.get('utm_source') ?? '',
    utm_medium: params.get('utm_medium') ?? '',
    utm_campaign: params.get('utm_campaign') ?? '',
    utm_term: params.get('utm_term') ?? '',
    utm_content: params.get('utm_content') ?? '',
  };
}
